import { useCallback } from 'react'

import { useUpdateUserSkins } from './useUpdateUserSkins'

export const useUpdateUserAvatarWithEffectSkin = ({
  onSuccess,
}: {
  onSuccess?: () => void
} = {}) => {
  const { loading, handleUpdateUserSkins } = useUpdateUserSkins({
    onSuccess,
  })

  const handleUpdateUserAvatarWithEffectSkin = useCallback(
    async (avatar?: string, effect?: string) => {
      await handleUpdateUserSkins({ avatar, avatarEffect: effect })
    },
    [handleUpdateUserSkins]
  )

  return {
    loading,
    handleUpdateUserAvatarWithEffectSkin,
  }
}
